import Cookies from 'js-cookie'
import * as Lockr from 'lockr'
import { clearCookies, clearLocalStorage } from '../logout-utils'
import { onLogin } from '../login/on-login'
import { refreshTokenUrl } from '@/root/api/apiConstants'
import { HTTP_STATUS_CODE } from '@/root/constants/api-status-codes'

export const handleLogout = (clearCookiesAndLS: boolean = true) => {
  if (clearCookiesAndLS) {
    clearCookies()
    clearLocalStorage()
  }
  window.location.href = `/login?return_to=${window.location.pathname.substring(
    0,
    1000,
  )}${window.location.search.substring(0, 1000)}`
}

export const handleRefreshToken = async (
  apiGatewayUrl: string,
  clearCookiesAndLS: boolean = true,
) => {
  try {
    const refreshToken = Cookies.get('refresh_token') ?? ''
    if (!refreshToken) {
      // if refresh_token is not present, then we need to logout the user
      handleLogout(clearCookiesAndLS)
      return null
    }

    const refreshTokenResp = await fetch(refreshTokenUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    })
    const refreshTokenRespJson = await refreshTokenResp.json()
    if (refreshTokenResp.status === HTTP_STATUS_CODE.SUCCESS) {
      // if API call is a success, then we need to set new Token in cookies and localStorage and verify new Encrypted Token on INDstocks (in onLogin())
      const newToken = refreshTokenRespJson.jwt_token
      const newEncryptedToken = refreshTokenRespJson.encrypted_token
      Lockr.set('token', newToken)
      Cookies.set('token', newToken, { secure: true })
      onLogin(false, newEncryptedToken, window.location.pathname)
      return newToken
    } else if (refreshTokenResp.status === HTTP_STATUS_CODE.BAD_REQUEST) {
      console.info('Bad Request For Refresh Token', apiGatewayUrl)
    } else {
      handleLogout(clearCookiesAndLS)
    }
  } catch (error: unknown) {
    console.info('Error in refreshToken:', { apiGatewayUrl }, error)
    handleLogout(clearCookiesAndLS)
  }
  return null
}
